import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	allInvited: {
		id: 'growth.inline-invite.success-panel.all-invited',
		description: 'Invite only message',
		defaultMessage:
			'Invitation sent to <bold>{invitedCount, plural, one {{email}} other {everyone}}</bold>',
	},
	allRequested: {
		id: 'growth.inline-invite.success-panel.all-requested',
		description: 'Request access only message',
		defaultMessage:
			'Access request sent to your admin for <bold>{requestedCount, plural, one {{email}} other {everyone}}</bold>',
	},
	hybridOneRequested: {
		id: 'growth.inline-invite.success-panel.hybrid-one-requested',
		description: 'Hybrid invite and request access message for one requested email',
		defaultMessage:
			"You've added <bold>{invitedCount, plural, one {1 person} other {# people}}</bold>, and requested access for {email}",
	},
	hybridOneInvited: {
		id: 'growth.inline-invite.success-panel.hybrid-one-invited',
		description: 'Hybrid invite and request access message for one invited email',
		defaultMessage:
			"You've added <bold>{email}</bold>, and requested access for {requestedCount} others",
	},
	hybrid: {
		id: 'growth.inline-invite.success-panel.hybrid',
		description: 'Hybrid invite and request access message',
		defaultMessage:
			"You've added <bold>{invitedCount} people</bold>, and requested access for {requestedCount} others",
	},
});

export default messages;
